
import * as OM from '@/model';
import { mixins, Options, Vue } from 'vue-class-component';
import withModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class stars extends Vue {

    @Prop() value: number;
    @Prop({
        default: 24
    }) size: number;
    
    // declare modelValue: number;

    // emitValue(val){
    //     this.emitModel(val);
    // }

}

